import React from 'react';
import PropTypes from 'prop-types';

const QuoteCarouselCard = ({ quote, person, quoteSubtitle }) => {
  return (
    <div className="quote-card">
      <div className="quote-card__content">
        <blockquote className="quote-card__text">"{quote}"</blockquote>
        <cite className="quote-card__subcontent">
          <span className="quote-card__identifier">{person}</span>
          <span className="quote-card__subtitle">{quoteSubtitle}</span>
        </cite>
      </div>
    </div>
  );
};

QuoteCarouselCard.propTypes = {
  quote: PropTypes.string.isRequired,
  person: PropTypes.string.isRequired,
  quoteSubtitle: PropTypes.string.isRequired,
};

export default QuoteCarouselCard;
